<template>
  <b-modal v-model="visible" :title="title" centered size="md" :hide-footer="true" @hidden="cancel">
    <b-form @submit.prevent="submit" novalidate>

      <validated-form-textarea v-if="visible" name="message"
                               v-model="message" :rows="2" :maxRows="8"
                               :autofocus="true"
                               :validate="required ? 'required' : ''"
                               :validator="$validator"/>

      <div class="float-right">
        <button type="button" class="btn btn-secondary-outline" @click.prevent="cancel">Loobu</button>
        <button type="submit" class="btn btn-primary">Salvesta</button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import Vue from 'vue'
  import ValidatedFormTextarea from './ValidatedFormTextarea'

  let eventBus = new Vue()

  export default {
    components: {ValidatedFormTextarea},
    install(Vue, options) {
      Vue.prototype.$prompt = function(title, action, options) {
        eventBus.$once('answer', response => {
          if (response !== false) action(response)
        })
        eventBus.$emit('ask', Object.assign({value: '', required: true}, {title}, options || {}))
      }
    },
    data() {
      return {
        title: '',
        message: '',
        visible: false,
        required: true
      }
    },
    methods: {
      cancel() {
        this.answer(false)
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.answer(this.message)
        })
      },
      answer(result) {
        this.visible = false
        eventBus.$emit('answer', result)
      }
    },
    created() {
      eventBus.$on('ask', ({title, value, required}) => {
        this.message = value || ''
        this.title = title
        this.visible = true
        this.required = required
      })
    }
  }
</script>